import React from "react";
import moment from "moment";
import Loader from "../loader";
import Helpers from "../../../helpers/helperFunctions";
import GameWrapper from "../../containers/gameWrapper";
import {t} from "../../../helpers/translator";

export default function virtualGamesListTemplates () {
    let { data, loaded, providerId } = this.props,
        { selectedGameId, defaultGameId } = this.state,
        gameId = this.state.selectedGameId && this.props.data.game[this.state.selectedGameId] ? this.props.data.game[this.state.selectedGameId].market > 0 ? this.state.selectedGameId : this.state.defaultGameId : this.state.defaultGameId;
    let isDualscreen = sessionStorage.getItem("dualscreen");
    if (data && loaded) {
        let games = Helpers.objectToArray(data.game);
        var timestamp = moment().unix();
        return [
            <div className="v-g-time-row" key={'container'}>
                <div className="v-g-t-contain">
                    {
                        isDualscreen !== "true"
                        ? <span className="open-statistics" onClick={this.handleClick}></span>
                        : null
                    }
                    {/* <button className="sports-navigation-scroll-buttons left-button" onMouseDown={() => {
                            this.handleMouseUp();
                            this.scroll(this.refs.scroller, -3, 4);
                        }}/> */}
                    <ul ref="scroller">
                        {/* <li>
                            <p>{t("UPCOMING GAMES")}</p>
                        </li> */}
                        {
                            games.map((game) => {
                                if (game.start_ts > timestamp) {
                                    return (
                                        <li key={game.id} onClick={() => this.selectGame(game.id)} className={game.id === (selectedGameId || defaultGameId) ? "active" : ""}>
                                            <span>{moment.unix(game.start_ts).format("HH:mm")}</span>
                                            <p>{t(`Round ID`)} {game.round}</p>
                                        </li>
                                    );
                                }
                            })
                        }
                    </ul>
                    {/* <button className="sports-navigation-scroll-buttons right-button" onMouseDown={() => {
                        this.handleMouseUp();
                        this.scroll(this.refs.scroller, 3, 4);
                    }}/> */}
                </div>
            </div>,
            <div className="sport-events-v-g" key={'wrapper'}>
                <div className="sport-events-container-v">
                    <GameWrapper virtualGameId={gameId} key={gameId} providerId={providerId} />
                </div>
            </div>
        ];
    } else {
        return <Loader/>;
    }
};